<template>
  <div class="form">
    <h1 class="title">新零售项目招商</h1>
    <p class="sub-title">本项目适合有意向销售卡车零配件的门店；商用车领域有客户资源的个人（门店）。</p>
    <div class="item">
      <span>姓名</span>
      <input @blur="onBlur" type="text" v-model="form.userName" maxlength="6" placeholder="请输入姓名" />
    </div>
    <div class="item">
      <span>电话</span>
      <input
        @blur="onBlur"
        type="number"
        maxlength="11"
        oninput="if(this.value.length > 11){this.value = this.value.slice(0,11)}"
        v-model="form.telNumber"
        placeholder="请输入电话"
      />
    </div>
    <input type="button" value="提交" @click="submit" />
  </div>
</template>
<script>
import XHR from '../api'

export default {
  name: 'BusinessForm',
  props: [],
  data: () => ({
    form: {
      userName: '',
      telNumber: ''
    }

  }),
  components: {

  },
  created () {
  },
  mounted () {
  },
  methods: {
    submit () {
      const info = {
        userName: '请填写姓名',
        telNumber: '请填写电话'
      }
      for (const item in info) {
        if (!this.form[item]) {
          this.$showToast.show({
            type: 'tip',
            text: info[item],
            time: 2000
          })
          return
        }
      }
      if (!this.isPhoneNum(this.form.telNumber)) {
        this.$showToast.show({
          type: 'tip',
          text: '请填写正确电话号码',
          time: 2000
        })
        return
      }
      XHR.signUp({
        name: escape(this.form.userName),
        phone: this.form.telNumber
      }).then(res => {
        const { status, data } = res.data
        if (!status) {
          if (data.msg === '已参加') {
            this.$showToast.show({
              type: 'tip',
              text: '您已经提交过啦~',
              time: 2000
            })
          } else {
            this.$showToast.show({
              type: 'success',
              text: '提交成功',
              time: 2000
            })
          }
          this.form = {
            userName: '',
            telNumber: ''
          }
        }
      }).catch(err => {
        console.log(err)
        this.$showToast.show({
          type: 'error',
          text: '网络原因，稍后重试',
          time: 2000
        })
      })
    }
  }
}
</script>
<style lang="less" scoped>
.form {
  position: relative;
  background: #f4f5f6;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  .title {
    font-size: 24px;
    color: #000000;
    line-height: 30px;
    padding: 28px 0 8px;
    text-align: center;
  }
  .sub-title {
    font-size: 14px;
    color: #6d7278;
    text-align: center;
    margin-bottom: 20px;
    padding: 0 20px;
  }
  .item {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 335px;
    height: 44px;
    margin: auto;
    background: #ffffff;
    padding: 0 12px;
    box-sizing: border-box;
    margin-bottom: 8px;
    span {
      font-size: 16px;
      color: #6d7278;
      margin-right: 12px;
    }
    input {
      flex: 1;
      -moz-appearance: textfield;
    }
  }

  input[type="button"] {
    background-image: linear-gradient(270deg, #3d83ff 0%, #3a48db 100%);
    box-shadow: 0 4px 8px 0 rgba(61, 114, 245, 0.4);
    font-size: 16px;
    color: #ffffff;
    height: 44px;
    line-height: 44px;
    margin: 8px auto 28px;
    width: 335px;
  }
}
@media screen and (min-width: 376px) {
  .form {
    padding-top: 60px;
    .title {
      font-size: 40px;
      color: #000000;
      text-align: center;
      line-height: 50px;
      padding: 0;
    }
    .sub-title {
      font-size: 20px;
      color: #6d7278;
      line-height: 30px;
      margin: 20px 0;
    }
    .item {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 400px;
      height: 44px;
      margin: auto;
      background: #ffffff;
      padding: 0 12px;
      box-sizing: border-box;
      margin-bottom: 10px;
      span {
        font-size: 16px;
        color: #6d7278;
        margin-right: 12px;
      }
      input {
        flex: 1;
        -moz-appearance: textfield;
      }
    }

    input[type="button"] {
      background-image: linear-gradient(270deg, #3d83ff 0%, #3a48db 100%);
      box-shadow: 0 4px 8px 0 rgba(61, 114, 245, 0.4);
      font-size: 16px;
      color: #ffffff;
      height: 44px;
      line-height: 44px;
      margin: 30px auto 64px;
      width: 400px;
    }
  }
}
</style>
